module.exports = __webpack_public_path__ + "static/media/volume.3b032bce.svg";